import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Atividade Recente',
  actions: {
    clicked: 'Clicado',
    open: 'Aberto',
    scheduled: 'Agendado',
    sent: 'Enviado',
  },
  fields: {
    recipients: '{{recipients}} Destinatários',
    opened: '{{rate}} Abertos',
    clicked: '{{rate}} Clicados',
    awaiting: 'A aguardar confirmação',
  },
  template_types: TemplateNames,
};
